<div *ngIf="isVisible" class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!-- Modal panel -->
      <div class="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">

        <form [formGroup]="companyForm" (ngSubmit)="saveCompany()">

          <!-- Close button -->
          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:opacity-90 focus:outline-none">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="px-4 py-4 lg:px-6 lg:py-6">
            <h3 class="text-2xl font-semibold text-gray-900 mb-6" id="modal-title">
              {{ mode === 'edit' ? 'Edit Company' : 'Create New Company' }}
            </h3>

            <div class="space-y-4">
              <!-- Company Name -->
              <fieldset [disabled]="loading">
                <label for="companyName" class="block text-sm font-medium leading-6 text-gray-900">
                  <span class="text-red-500 mr-1">*</span>Company name
                </label>
                <div class="mt-2">
                  <input
                    type="text"
                    id="companyName"
                    name="companyName"
                    formControlName="companyName"
                    placeholder="Enter company name"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  />
                </div>
                <div class="pt-1" *ngIf="companyForm.get('companyName')?.touched && companyForm.get('companyName')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="companyForm.get('companyName')?.errors?.['required']">
                    Company name is required.
                  </div>
                </div>
              </fieldset>

              <!-- Domain -->
              <fieldset [disabled]="loading">
                <label for="domain" class="block text-sm font-medium leading-6 text-gray-900">
                  Domain
                </label>
                <div class="mt-2">
                  <input
                    type="text"
                    id="domain"
                    name="domain"
                    formControlName="domain"
                    placeholder="Enter domain"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  />
                </div>
                <div class="pt-1" *ngIf="companyForm.get('domain')?.touched && companyForm.get('domain')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="companyForm.get('domain')?.errors?.['pattern']">
                    Please enter a valid domain (e.g., example.com).
                  </div>
                </div>
              </fieldset>

              <!-- Existing Contacts (Edit mode only) -->
              <div *ngIf="mode === 'edit' && existingContacts.length > 0">
                <label class="block text-sm font-medium leading-6 text-gray-900 mb-2">
                  Existing Contacts
                </label>
                <div class="space-y-2">
                  <div *ngFor="let companyContact of existingContacts" class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div class="flex items-center space-x-3">
                      <div class="size-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <span class="text-primary text-sm font-medium">
                          {{ (companyContact.contact?.name?.charAt(0) || '') + (companyContact.contact?.surname?.charAt(0) || '') }}
                        </span>
                      </div>
                      <div class="flex-1">
                        <p class="text-sm font-medium text-gray-900">
                          {{ companyContact.contact?.name || 'Unknown' }} {{ companyContact.contact?.surname || 'Contact' }}
                        </p>
                        <p class="text-xs text-gray-500">{{ companyContact.contact?.email || 'No email' }}</p>
                        <span class="text-xs text-gray-500" *ngIf="companyContact.is_default === 1">Primary Contact</span>
                      </div>
                    </div>
                    <button
                      type="button"
                      (click)="removeContact(companyContact.id)"
                      class="p-2 text-red-600 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                      title="Remove contact">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                        <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Select existing Contact -->
              <fieldset [disabled]="loading">
                <label for="contactId" class="block text-sm font-medium leading-6 text-gray-900">
                  {{ mode === 'edit' ? 'Add Another Contact' : 'Select existing Contact' }}
                </label>
                <div class="mt-2">
                  <select
                    id="contactId"
                    name="contactId"
                    formControlName="contactId"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary sm:text-sm/6"
                  >
                    <option value="">Select contact</option>
                    <option *ngFor="let contact of contacts" [value]="contact.id">
                      {{ contact.name }} {{ contact.surname }}
                    </option>
                  </select>
                </div>
              </fieldset>

            </div>
          </div>

          <!-- Action buttons -->
          <div class="px-4 sm:px-6 pb-6 grid grid-cols-2 gap-4">
            <button
              type="button"
              (click)="closeModal()"
              [disabled]="loading"
              class="w-full rounded-md px-4 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed">
              Cancel
            </button>
            <button
              type="submit"
              [disabled]="loading || companyForm.invalid"
              class="w-full rounded-md px-4 py-3 text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed">
              <span *ngIf="!loading">Save Company</span>
              <span *ngIf="loading" class="flex items-center justify-center">
                <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </span>
            </button>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>
